import React from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';
const { FiArrowLeft, FiArrowRight, FiZap, FiDollarSign } = FiIcons;

export default function AboutPage() {
  const { setCurrentPage, setMode } = useAppContext();
  const handleClaim = () => { setCurrentPage('home'); setMode('select'); };

  return (
    <div className="min-h-screen" style={{ background: '#080012', fontFamily: 'Courier New,monospace', color: '#fff', overflowY: 'auto' }}>
      <div className="px-8 pt-8">
        <button onClick={() => setCurrentPage('home')} className="flex items-center gap-2 text-pink-500 hover:text-pink-300 transition-colors font-bold uppercase tracking-widest" style={{ fontSize: '15px' }}>
          <FiArrowLeft /> Back to Grid
        </button>
      </div>
      <div className="max-w-2xl mx-auto px-8 py-12 pb-24">
        <h1 className="font-black uppercase mb-8 leading-none" style={{ color: '#ff00cc', fontFamily: 'Impact,sans-serif', letterSpacing: '3px', fontSize: 'clamp(40px,8vw,80px)' }}>
          WHAT IS THIS?
        </h1>
        <p className="leading-relaxed mb-5" style={{ color: '#e2e8f0', fontSize: '18px' }}>
          In 2005, a student sold 1,000,000 pixels for $1 each. It became a legendary piece of internet history.
        </p>
        <p className="leading-relaxed mb-12" style={{ color: '#e2e8f0', fontSize: '18px' }}>
          This is the 2026 reboot. 1,000,000 pixels. A blank canvas. An exercise in digital real estate, ego, art, and chaos.
        </p>
        <div className="mb-12" style={{ borderBottom: '1px solid rgba(255,0,200,0.2)' }} />
        <div className="mb-12">
          <h2 className="font-black uppercase tracking-widest mb-5" style={{ color: '#ff00cc', fontSize: '16px' }}>HOW IT WORKS</h2>
          <ul className="space-y-4">
            {[
              'The grid is 1000 × 1000 pixels.',
              'Pixels are sold in 10 × 10 blocks.',
              'You can claim any available area.',
              "Once claimed, it's yours. Add a link, a title, an image, or a solid neon color.",
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3" style={{ color: '#e2e8f0', fontSize: '17px' }}>
                <span style={{ color: '#ff00cc', fontSize: '18px' }}>•</span>{item}
              </li>
            ))}
          </ul>
        </div>
        <div className="mb-12" style={{ borderBottom: '1px solid rgba(255,0,200,0.2)' }} />
        <div className="mb-12">
          <h2 className="font-black uppercase tracking-widest mb-5" style={{ color: '#ff00cc', fontSize: '16px' }}>WHY BUY PIXELS?</h2>
          <ul className="space-y-4">
            {[
              'Permanent placement — your block never moves or expires.',
              'Prices increase as more pixels are sold. Early buyers win.',
              'Every pixel links back to your site — real SEO value.',
              'Be part of internet history. Again.',
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3" style={{ color: '#e2e8f0', fontSize: '17px' }}>
                <span style={{ color: '#ff00cc', fontSize: '18px' }}>•</span>{item}
              </li>
            ))}
          </ul>
        </div>
        <div className="mb-12" style={{ borderBottom: '1px solid rgba(255,0,200,0.2)' }} />
        <div className="mb-12">
          <h2 className="font-black uppercase tracking-widest mb-5" style={{ color: '#ff00cc', fontSize: '16px' }}>PRICING TIERS</h2>
          <div className="space-y-0">
            {[
              { range: '0 – 100,000 px',       price: '$0.15 / px', current: true },
              { range: '100,001 – 200,000 px',  price: '$0.25 / px' },
              { range: '200,001 – 350,000 px',  price: '$0.40 / px' },
              { range: '350,001 – 500,000 px',  price: '$0.65 / px' },
              { range: '500,001 – 650,000 px',  price: '$1.00 / px' },
              { range: '650,001 – 800,000 px',  price: '$1.75 / px' },
              { range: '800,001 – 900,000 px',  price: '$2.50 / px' },
              { range: '900,001 – 1,000,000 px', price: '$4.00 / px' },
            ].map((tier, i) => (
              <div key={i} className="flex justify-between items-center py-3 border-b border-gray-800">
                <div className="flex items-center gap-2">
                  <span style={{ color: '#9ca3af', fontSize: '15px' }}>{tier.range}</span>
                  {tier.current && (
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-black uppercase" style={{ background: 'rgba(255,0,200,0.15)', color: '#ff00cc', border: '1px solid rgba(255,0,200,0.4)' }}>
                      CURRENT
                    </span>
                  )}
                </div>
                <span className="font-black" style={{ color: tier.current ? '#ff00cc' : '#9ca3af', fontSize: '17px' }}>{tier.price}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Affiliate CTA */}
        <div className="mb-12 p-5 rounded-2xl" style={{ background: 'linear-gradient(135deg,rgba(255,0,200,0.08),rgba(204,0,255,0.08))', border: '1px solid rgba(255,0,200,0.3)' }}>
          <div className="flex items-center gap-2 mb-2">
            <FiDollarSign className="text-pink-500" />
            <span className="font-black text-white uppercase tracking-wider text-sm">Earn While You Refer</span>
          </div>
          <p className="text-gray-400 text-sm mb-3">Share your unique link and earn <span className="text-pink-400 font-black">20% commission</span> on every pixel sale you drive. No cap.</p>
          <button onClick={() => setCurrentPage('affiliate')}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl font-black text-sm uppercase tracking-wider text-white transition-all hover:scale-105"
            style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)' }}>
            <FiZap /> Join Affiliate Program <FiArrowRight />
          </button>
        </div>

        <button onClick={handleClaim} className="w-full py-6 rounded-xl font-black uppercase tracking-widest text-white transition-all hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-3 mb-10"
          style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)', fontFamily: 'Impact,sans-serif', letterSpacing: '3px', fontSize: '24px', boxShadow: '0 0 30px rgba(255,0,200,0.4)' }}>
          <FiZap /> CLAIM YOUR SPOT <FiArrowRight />
        </button>
      </div>
    </div>
  );
}